module.exports = "/assets/7649d19e97620547d4a65c368ac0ccf5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/eurostar.svg
// module id = 3598
// module chunks = 0